export default {
    computed: {
        console: () => console,
        window: () => window,
    },
}